<template>
  <a-card class="relative">
    <div v-if="upload.uploadLoading" style="text-align: center">
      上传中 已完成{{ upload.progress + "%"
      }}<a-spin style="margin-left: 5px" />
    </div>
    <a-button class="back" @click="backHandle">返回</a-button>
    <Globalnfo :info="detail.info"></Globalnfo>

    <a-card class="mt20" title="基本信息">
      <div class="wrap">
        <div class="con">
          <dl>
            <dt>数据集：</dt>
            <dd v-if="!isOther">
              {{ detail.info?.dataset?.chineseInstructions }}
            </dd>
            <dd v-else>
              <span
                v-if="detail.info.state != 'to_be_submitted'"
                style="color: #0c2366; cursor: pointer"
                @click="downloadHanlder"
                >下载</span
              >
            </dd>
          </dl>
          <dl>
            <dt>说明：</dt>
            <dd>{{ detail.info.description }}</dd>
          </dl>
        </div>

        <div class="con">
          <dl v-if="detail.info.type == 'tag'">
            <dt>筛选标签：</dt>
            <dd>
              {{ detail.info.tags.join(",") }}
            </dd>
          </dl>

          <dl v-else>
            <dt>标注说明：</dt>
            <dd><a :href="detail.docUrl" target="_blank" download>下载</a></dd>
          </dl>

          <dl>
            <dt>路径：</dt>
            <dd>
              <span>{{ detail.info.filePath }}</span>
            </dd>
          </dl>
        </div>
        <!-- <div class="con" v-if="westCurrentRole.roleId == 7 || westCurrentRole.roleId == 8 ||  westCurrentRole.roleId == 11 ||  westCurrentRole.roleId == 12" >
          <dl>
            <dt>采购经理：</dt>
            <dd>{{ detail.info?.purchaseManager?.name }}</dd>
          </dl>
        </div> -->
      </div>
    </a-card>
    <a-card
      v-if="
        westCurrentRole.roleId == 7 ||
        westCurrentRole.roleId == 8 ||
        westCurrentRole.roleId == 11 ||
        westCurrentRole.roleId == 12 ||
        westCurrentRole.roleId == 13 ||
        westCurrentRole.roleId == 14
      "
      class="mt20"
      title="项目信息"
    >
      <div class="wrap">
        <div class="con">
          <dl>
            <dt>所属项目：</dt>
            <dd>{{ detail.info.project.projectName }}</dd>
          </dl>
          <dl>
            <dt>标注公司：</dt>
            <dd>{{ detail.info.annotationCompanyName }}</dd>
          </dl>
        </div>

        <div class="con">
          <dl>
            <dt>项目编号：</dt>
            <dd>{{ detail.info.project.projectNumber }}</dd>
          </dl>
          <dl>
            <dt>预估费用：</dt>
            <dd>{{ detail.info.estimatedCost }}</dd>
          </dl>
        </div>
        <div class="con">
          <dl>
            <dt>项目经理：</dt>
            <dd>{{ detail.info.project.projectManager }}</dd>
          </dl>
          <dl>
            <dt>标注方式：</dt>
            <dd>{{ stateTocn() }}</dd>
          </dl>
        </div>
      </div>
    </a-card>
    <div>
      <a-card v-if="!isOther" class="mt20" title="任务信息">
        <div class="wrap">
          <div class="con">
            <dl>
              <dt>任务状态：</dt>
              <dd>{{ stateCn(detail.info.state) }}</dd>
              <dd
                v-if="
                  (detail.info.state == 'rejected' ||
                    detail.info.state == 'terminated') &&
                  detail.info.approvedResult
                "
                class="ml20"
              >
                <a @click.prevent="reasonView(detail.info.approvedResult)"
                  >查看原因</a
                >
              </dd>
              <dd
                v-if="
                  detail.info.state == 'to_be_submitted' &&
                  detail.info.page == 'operate' &&
                  detail.info.approvedResult
                "
                class="ml20"
              >
                <a @click.prevent="reasonView(detail.info.approvedResult)"
                  >查看原因</a
                >
              </dd>
            </dl>
            <dl>
              <dt>任务总量：</dt>
              <dd>
                {{ detail.info.detailTotal }}
                <a
                  v-if="detail.info.detailTotal"
                  @click="toDataItem('main', detail.info)"
                  >查看数据</a
                >
              </dd>
            </dl>
          </div>
          <div class="con">
            <dl>
              <dt>子任务数量：</dt>
              <dd>
                {{ detail.info.subTotal }}
                <a
                  v-if="detail.info.subTotal"
                  @click="toDataItem('sub', detail.info)"
                  >查看子任务</a
                >
              </dd>
            </dl>
          </div>
          <div
            class="con"
            v-if="
              westCurrentRole.roleId == 7 ||
              westCurrentRole.roleId == 8 ||
              westCurrentRole.roleId == 11 ||
              westCurrentRole.roleId == 12
            "
          >
            <dl>
              <dt>初验比例：</dt>
              <dd v-if="detail.info.spotCheckProportion">
                {{ detail.info.spotCheckProportion }} %
              </dd>
            </dl>
          </div>
        </div>
      </a-card>
      <a-card v-else class="mt20" title="任务信息">
        <div class="wrap">
          <div class="con">
            <dl>
              <dt>任务状态：</dt>
              <dd>{{ stateCn(detail.info.state) }}</dd>
              <dd
                v-if="
                  (detail.info.state == 'rejected' ||
                    detail.info.state == 'terminated') &&
                  detail.info.approvedResult
                "
                class="ml20"
              >
                <a @click.prevent="reasonView(detail.info.approvedResult)"
                  >查看原因</a
                >
              </dd>
              <dd
                v-if="
                  detail.info.state == 'to_be_submitted' &&
                  detail.info.page == 'operate' &&
                  detail.info.approvedResult
                "
                class="ml20"
              >
                <a @click.prevent="reasonView(detail.info.approvedResult)"
                  >查看原因</a
                >
              </dd>
            </dl>
            <dl
              v-if="
                detail.info.page == 'server' || detail.info.page == 'operate'
              "
            >
              <dt>标注结果：</dt>
              <dd class="label-result">
                <div v-if="detail.info.page == 'server'">
                  <div
                    style="position: relative"
                    v-if="
                      detail.info.state != 'rejected' &&
                      detail.info.state != 'label_completed' &&
                      detail.info.state != 'completed' &&
                      detail.info.state != 'terminated'
                    "
                  >
                    <div
                      class="mb10"
                      v-for="file in detail.info.paths"
                      :key="file.url"
                    >
                      <a :href="host + file.url + '?type=download'">{{
                        file.filename
                      }}</a>
                      <span @click="delFile(file)" class="ml10 red">删除</span>
                    </div>
                    <!-- <a-upload
                      v-model:file-list="file.list"
                      :showUploadList="false"
                      name="file"
                      :multiple="false"
                      :action="action"
                      :headers="headers"
                      @change="handleChange"
                    >
                      <a-button :loading="editLoading">
                        上传<span v-if="editLoading">中</span>
                      </a-button>
                    </a-upload> -->

                    <a-upload
                      ref="uploadCom"
                      :customRequest="uploadRequest"
                      v-model:file-list="file.list"
                      :showUploadList="false"
                      name="file"
                      :multiple="false"
                      :auto-upload="false"
                    >
                      <!-- <a-button :loading="editLoading">
                          上传<span v-if="editLoading">中</span>
                        </a-button> -->
                      <!-- <a ref="uploadBtn" type="text">上传</a> -->
                      <a-button :loading="editLoading">
                        上传<span v-if="editLoading">中</span>
                      </a-button>
                    </a-upload>

                    <!-- <a-button @click="uploadHandle()" class="gap-btn">
                    </a-button> -->
                    <span class="ml10">{{ fileName }}</span>

                    <!-- <a-button :disabled="editLoading"  v-if="file.list.length > 0" class="mt20" type="primary" @click="editFile">确认</a-button> -->
                  </div>

                  <div v-else>
                    <div
                      class="mb10"
                      v-for="file in detail.info.paths"
                      :key="file.url"
                    >
                      <a :href="host + file.url + '?type=download'">{{
                        file.filename
                      }}</a>
                    </div>
                  </div>
                </div>
                <!-- 只读时 -->
                <div v-else>
                  <div
                    class="mb10"
                    v-for="file in detail.info.paths"
                    :key="file.url"
                  >
                    <a :href="host + file.url + '?type=download'">{{
                      file.filename
                    }}</a>
                  </div>
                </div>
              </dd>
            </dl>
          </div>
        </div>
      </a-card>
    </div>
  </a-card>
  <!--  下载弹框 -->
  <a-modal
    v-model:visible="downloadData.visible"
    :maskClosable="false"
    title="下载"
  >
    下载方式：
    <a-radio-group name="radioGroup" v-model:value="downloadData.type">
      <a-radio value="zip">zip包</a-radio>
      <a-radio value="file">单文件</a-radio>
      <a-radio value="page">外部下载</a-radio>
    </a-radio-group>
    <!-- <p style="color:#ff0000;" class="mt30">注：若需将标注更新至数据集，请将下载的标注再次上传至平台，对应数据将被更新。</p> -->
    <template #footer>
      <a-button key="back" @click="downloadData.visible = false">取消</a-button>
      <a-button
        key="submit"
        type="primary"
        :loading="downloadData.loading"
        @click="downloadFile"
        >确认</a-button
      >
    </template>
  </a-modal>
</template>
<script>
import axios from "axios";
import { useStore } from "@/store/index2";
import Globalnfo from "./Globalnfo";
import { useRoute, useRouter } from "vue-router";
import { getShareUrls } from "@/api/system";
import {
  forView,
  editUploadPath,
  addUploadPath,
  removeUploadPath,
} from "@/api/taskRelease";
import { reactive, h, getCurrentInstance } from "vue";
import { publicConfig } from "@/publicConfig.js";
import { Modal, message } from "ant-design-vue";

import { md5 } from "js-md5";

const token = localStorage.getItem("westToken");

export default {
  components: {
    Globalnfo,
  },
  data() {
    return {
      submitLoading: false,
      editLoading: false,
      delSubmitLoading: false,
      loading: false,
      host: publicConfig.requestUrl,
      action: publicConfig.requestUrl + "/system/api/file/upload", //publicConfig.requestUrl
      headers: { Authorization: "bearer " + token }, //Cookies.get('access_token')

      tipShow: false,
      showFileDialog: false,

      fileName: "",
      downloadData: {
        visible: false,
        loading: false,
        type: "zip",
      },
    };
  },
  computed: {
    isOther() {
      let takType = this.detail.info.type;
      return takType == "box3d" || takType == "video" || takType == "other";
    },
  },
  watch: {
    // 'file.list':{
    //   handler(val){
    //     console.log(val)
    //     console.log('change')
    //     let tmp = []
    //     val.forEach((item)=>{
    //       console.log('vv')
    //       if(item.response){
    //         tmp.push({
    //           url:item.response.url,
    //           name:item.response.name,
    //           filename:item.response.filename
    //         })
    //       }else{
    //         tmp.push(item)
    //       }
    //     })
    //     this.file.list = [...tmp]
    //   },
    //   deep:true,
    //   //immediate:true
    // },
    // 'detail.info.paths':{
    //   handler(val){
    //     if(val){
    //       val.forEach((item)=>{
    //         item.name= item.filename
    //       })
    //       this.fileList = [...val]
    //     }
    //   },
    //   deep:true,
    //   immediate:true
    // }
  },
  mounted() {},

  methods: {
    uploadFile() {
      //Modal.success('上传成功')
    },

    editFile() {
      let paths = [];
      this.file.list.forEach((item) => {
        paths.push({
          url: item.oriUrl,
          filename: item.filename,
        });
      });

      let reqData = {
        labelTaskId: this.detail.info.id,
        paths,
      };
      this.editLoading = true;
      editUploadPath(reqData)
        .then(() => {
          message.success("修改成功");
          this.editLoading = false;
        })
        .catch(() => {
          message.error("修改失败");
          this.editLoading = false;
        });
    },
    handleChange(data) {
      console.log(data);
      debugger;
      this.fileName = data.file.name;

      this.editLoading = true;
      if (data.file.response) {
        let reqData = {
          file: {
            filename: data.file.response.data.filename,
            url: data.file.response.data.url,
          },
          labelTaskId: this.detail.info.id,
        };
        this.fileName = "";
        addUploadPath(reqData)
          .then(({ data }) => {
            if (data.code == 0) {
              message.success("修改成功");
              this.getForView();
            } else {
              message.error(data.msg);
            }
            this.editLoading = false;
          })
          .catch(() => {
            this.getForView();
            this.editLoading = false;
          });
      }
    },
    delFile(file) {
      //this.detail.info.paths.splice(index, 1)
      if (this.delSubmitLoading) {
        return;
      }
      this.delSubmitLoading = true;
      let reqData = {
        file: file,
        labelTaskId: this.detail.info.id,
      };
      removeUploadPath(reqData)
        .then(({ data }) => {
          if (data.code == 0) {
            message.success("修改成功");
            this.getForView();
          } else {
            message.error(data.msg);
          }

          this.delSubmitLoading = false;
        })
        .catch(() => {
          this.delSubmitLoading = false;
        });
    },
    downloadHanlder() {
      this.downloadData.visible = true;
    },
    async downloadFile() {
      if (this.downloadData.loading) return;

      this.downloadData.loading = true;
      let type = this.downloadData.type;

      const { data: res } = await getShareUrls(this.detail.info.sharePath, "");
      if (type == "zip") {
        window.open(res.data.zip);
        this.downloadData.visible = false;
      } else if (type == "file") {
        debugger;
        var fileName = this.detail.info.name;
        var content = "";
        res.data.files.forEach((element) => {
          content += element + "\n";
        });
        const textFileAsBlob = new Blob([content], { type: "text/plain" });
        const downloadLink = document.createElement("a");
        downloadLink.download = fileName;
        downloadLink.href = URL.createObjectURL(textFileAsBlob);
        downloadLink.click();
        this.downloadData.visible = false;
      } else if (type == "page") {
        window.open(res.data.page, "_blank");
        this.downloadData.loading = false;
        this.downloadData.visible = false;
      } else {
        message.error("数据异常，下载失败");
      }
      this.downloadData.loading = false;
      console.log(res);
    },
  },
  setup() {
    const { proxy } = getCurrentInstance();

    const route = useRoute();
    const router = useRouter();

    const detail = reactive({
      info: {
        dataset: {},
        project: {},
        purchaseManager: {},
        docUrl: "",
      },
    });

    const file = reactive({
      item: {},
      list: [],
    });

    const westCurrentRole = JSON.parse(localStorage.getItem("westCurrentRole"));

    let upload = reactive({
      uploadLoading: false,
      action: publicConfig.requestUrl + "/system/api/file/chunkFileUpload",
      headers: {
        Authorization: "bearer " + token,
        "Content-Type": "multipart/form-data",
      }, //Cookies.get('access_token')
      fileList: [],
      tipShow: false,
      showFileDialog: false,
      chunkSize: 1024 * 1024 * 5, // 每个切片大小为50MB
      chunks: 0,
      currentChunkIndex: 0,
      progress: 0,
    });

    function uploadHandle() {}

    const getFileMd5 = (file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.onload = function (e) {
          resolve(md5(e.target.result));
        };
        reader.onerror = function (err) {
          reject(err);
        };
      });
    };

    async function uploadChunks(file) {
      upload.uploadLoading = true;
      getFileMd5(file)
        .then(async (fileMd5) => {
          while (upload.currentChunkIndex < upload.chunks) {
            const start = upload.currentChunkIndex * upload.chunkSize;
            const end = Math.min(start + upload.chunkSize, file.size);
            const chunk = file.slice(start, end);

            const formData = new FormData();
            let chunkMd5 = await getFileMd5(chunk);
            formData.append("chunkSize", upload.chunkSize);
            formData.append("chunks", upload.chunks);
            formData.append("file", chunk, `${file.name}`);
            formData.append("fileMd5", fileMd5);
            formData.append("currentChunkMd5", md5(chunkMd5));
            formData.append("size", file.size);
            formData.append("currentChunk", upload.currentChunkIndex);
            const config = {
              url: upload.action,
              method: "POST",
              //timeout: 30000, // 设置超时时间为30秒
              headers: upload.headers, // 可以添加请求头信息
              data: formData,
            };

            try {
              let { data } = await axios.request(config);

              console.log(data);

              if (data.code === 0) {
                upload.currentChunkIndex++;
                console.log(data);
                debugger;
                upload.progress = Math.floor(
                  (parseInt(upload.currentChunkIndex) /
                    parseInt(upload.chunks)) *
                    100
                );

                if (upload.currentChunkIndex === upload.chunks) {
                  upload.uploadLoading = false;
                  message.success("上传成功");

                  console.log("instance");
                  console.log(proxy);
                  debugger;

                  proxy.fileName = data.data.filename;

                  proxy.editLoading = true;

                  let reqData = {
                    file: {
                      filename: data.data.filename,
                      url: data.data.url,
                    },
                    labelTaskId: proxy.detail?.info?.id,
                  };

                  console.log(reqData);
                  debugger;
                  proxy.fileName = "";
                  addUploadPath(reqData)
                    .then(({ data }) => {
                      if (data.code == 0) {
                        //message.success("修改成功");
                        getForView();
                      } else {
                        //message.error(data.msg);
                      }
                      proxy.editLoading = false;
                    })
                    .catch(() => {
                      getForView();
                      proxy.editLoading = false;
                    });
                }
              } else {
                upload.uploadLoading = false;
                upload.fileList = [];
                message.error("文件上传失败");
                break;
              }
            } catch (err) {
              message.error("上传异常:" + err);
              upload.uploadLoading = false;
              upload.fileList = [];
              break;
            }
          }
        })
        .catch((err) => {
          message.error("文件读取失败");
        });
    }

    async function uploadRequest({ file, onSuccess, onError }) {
      debugger;
      upload.chunks = Math.ceil(file.size / upload.chunkSize); // 计算切片数量
      upload.currentChunkIndex = 0;
      upload.progress = 0;
      await uploadChunks(file);
    }

    async function getForView() {
      let params = {
        labelTaskId: route.query.taskId || "",
      };
      const { data: res } = await forView(params);
      detail.info = { ...res.data };
      if (!detail.info.paths) {
        detail.info.paths = [];
      }

      detail.info.page = route.query.page;
      detail.info.pageType = route.query.pageType;
      detail.docUrl = `${publicConfig.requestUrl}${detail.info.descriptionLink}`; //?token=${localStorage.getItem('westToken')}

      console.log(detail.info);

      // detail.info.paths?.forEach((item)=>{
      //   item.name= item.filename
      // })

      //file.list = [...detail.info.paths]

      // let tmp = []
      // file.list.forEach((item)=>{
      //   if(item.response){
      //     tmp.push({
      //       url:item.response.data.url + '?type=download',
      //       oriUrl:item.response.data.url,
      //       name:item.response.data.filename,
      //       filename:item.response.data.filename
      //     })
      //   }else{
      //     tmp.push(item)
      //   }

      // })

      // //file.list = []
      // file.list = [...tmp]
    }

    getForView();

    let store = useStore();
    function stateCn(value) {
      return store.getStateName(value);
    }

    let subTask = JSON.parse(localStorage.getItem("subTask"));
    function toDataItem(from, info) {
      let page = route.query.page;
      if (info.subTotal == 0) {
        router.push(`/labelDetail?taskId=${info.id}&from=${from}&page=${page}`); //查看总任务
      } else {
        router.push(
          `/labelDetail?taskId=${info.id}&subTaskId=${subTask[0].id}&from=${from}&type=view`
        ); //查看子任务
      }
    }

    //let subTaskIds = localStorage.getItem('subTaskIds') ? JSON.parse(localStorage.getItem('subTaskIds')) : []

    function backHandle() {
      router.back();
    }

    function reasonView(reason) {
      Modal.info({
        title: () => "原因",
        content: () => h("div", {}, [h("p", reason)]),
        onOk() {
          console.log("ok");
        },
      });
    }

    function stateTocn() {
      if (detail.info.labelType == "online") {
        return "线上";
      } else if (detail.info.labelType == "offline") {
        return "线下";
      } else {
        return "";
      }
    }

    return {
      westCurrentRole,
      detail,
      file,
      getForView,
      stateCn,
      backHandle,
      toDataItem,
      reasonView,
      stateTocn,
      upload,
      uploadRequest,
      uploadHandle,
    };
  },
};
</script>
<style lang="less" scoped>
/deep/ .ant-upload-list-item-name {
  padding-right: 15px;
}
.back {
  position: absolute;
  right: 50px;
  top: 50px;
  z-index: 1;
}
.wrap {
  display: flex;
  .con {
    margin-right: 200px;
    dl {
      display: flex;
    }
  }
}

.red {
  color: red;
  cursor: pointer;
  position: relative;
  z-index: 2;
}
</style>
